
import { timestampToTime, getUrlKey } from "@/utils/index"
import { defineComponent,toRefs,reactive } from 'vue';

export default defineComponent({
  setup(){
      interface DataProps{
        leaderboardArr:any;
      }
      const data:DataProps = reactive({
            tableColumnWidth: window.screen.width < 500 ? '100' : '140',
            leaderboardArr:[
                {
                    title: 'All-time Leaderboard',
                    startTime: '',
                    endTime: 'May.10',
                    tableData:[
                        {
                            name: 'Ke***.J',
                            inviteNum: '207',
                            inviteEarnings: '628'
                        },
                        {
                            name: 'Jo**.S',
                            inviteNum: '181',
                            inviteEarnings: '550'
                        },
                        {
                            name: 'Gr***.G',
                            inviteNum: '155',
                            inviteEarnings: '472'
                        }
                    ]
                },
            ]
      })
      const refData = toRefs(data)
      return {
          ...refData
      }
  }
})
